import * as React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Styles from './Hero.module.css';

const Hero = () => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);

  const [searchParams, setSearchParams] = useState({
    pickupLocation: '',
    returnLocation: '',
    pickupDate: '',
    pickupTime: '',
    returnDate: '',
    returnTime: '',
    carModel: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchParams({
      ...searchParams,
      [name]: value
    });
  };

  const expandForm = () => {
    if (!isExpanded) setIsExpanded(true);
  };

  const isTbilisi = (location) => location?.includes('Tbilisi');

  // თბილისი: 09-18
  const tbilisiTimes = [];
  for (let h = 9; h <= 18; h++) {
    tbilisiTimes.push(`${h.toString().padStart(2, '0')}:00`);
  }

  // ყველა დრო: 00-23
  const allTimes = [];
  for (let h = 0; h <= 23; h++) {
    allTimes.push(`${h.toString().padStart(2, '0')}:00`);
  }

  const getTimeOptions = (location) => {
    const times = isTbilisi(location) ? tbilisiTimes : allTimes;

    return (
      <>
        <option value="">Select time *</option>
        {times.map((t) => (
          <option key={t} value={t}>
            {t}
          </option>
        ))}
      </>
    );
  };

  const handleSearch = (e) => {
    e.preventDefault();

    navigate('/search-results', {
      state: {
        searchParams
      }
    });
  };

  return (
    <form onSubmit={handleSearch} className={Styles.forma}>
      {/* FIRST ROW */}
      <div className={Styles.form_sort} onClick={expandForm}>
        <div className={Styles.input_enter}>
          <select
            className={Styles.dizain_select}
            name="pickupLocation"
            value={searchParams.pickupLocation}
            onChange={(e) => {
              handleInputChange(e);
              expandForm();
            }}
            required
          >
            <option value="">Enter your pick-up location *</option>
            <option value="Tbilisi Office">Tbilisi Office</option>
            <option value="Tbilisi Airport">Tbilisi Airport</option>
            <option value="Qutaisi Office">Qutaisi Office</option>
            <option value="Batumi Office">Batumi Office</option>
          </select>
        </div>

        <div className={Styles.input_enter}>
          <input
            className={Styles.dizain_date}
            type="date"
            name="pickupDate"
            value={searchParams.pickupDate}
            onChange={(e) => {
              handleInputChange(e);
              expandForm();
            }}
            required
          />
        </div>

        {/* PICKUP TIME (SELECT) */}
        <div className={Styles.input_enter}>
          <select
            className={Styles.dizain_time}
            name="pickupTime"
            value={searchParams.pickupTime}
            onChange={(e) => {
              handleInputChange(e);
              expandForm();
            }}
            required
          >
            {getTimeOptions(searchParams.pickupLocation)}
          </select>
        </div>
      </div>

      {/* EXPANDED FIELDS */}
      {isExpanded && (
        <>
          <div className={Styles.form_sort}>
            <div className={Styles.input_enter}>
              <select
                className={Styles.dizain_select}
                name="returnLocation"
                value={searchParams.returnLocation}
                onChange={handleInputChange}
                required
              >
                <option value="">Return location *</option>
                <option value="Tbilisi Office">Tbilisi Office</option>
                <option value="Tbilisi Airport">Tbilisi Airport</option>
                <option value="Qutaisi Office">Qutaisi Office</option>
                <option value="Batumi Office">Batumi Office</option>
              </select>
            </div>

            <div className={Styles.input_enter}>
              <input
                className={Styles.dizain_date}
                type="date"
                name="returnDate"
                value={searchParams.returnDate}
                onChange={handleInputChange}
                required
              />
            </div>

            {/* RETURN TIME (SELECT) */}
            <div className={Styles.input_enter}>
              <select
                className={Styles.dizain_time}
                name="returnTime"
                value={searchParams.returnTime}
                onChange={handleInputChange}
                required
              >
                {getTimeOptions(searchParams.returnLocation)}
              </select>
            </div>
          </div>

          <div className={Styles.form_sort}>
            <div className={Styles.input_enter}>
              <select
                className={Styles.dizain_select_age}
                name="carModel"
                value={searchParams.carModel}
                onChange={handleInputChange}
                required
              >
                <option value="">Select car *</option>
                <option value="Hyundai Tucson">Hyundai Tucson</option>
                <option value="Nissan Micra">Nissan Micra</option>
                <option value="Renault Duster">Renault Duster</option>
                <option value="Renault Logan">Renault Logan</option>
                <option value="Renault Sandero">Renault Sandero</option>
                <option value="Toyota Corolla">Toyota Corolla</option>
                <option value="Toyota Fortuner">Toyota Fortuner</option>
                <option value="Toyota Prado">Toyota Prado</option>
                <option value="Toyota Yaris">Toyota Yaris</option>
                <option value="Toyota Rav4">Toyota Rav4</option>
                <option value="Hyundai Creta">Hyundai Creta</option>
              </select>
            </div>

            <div className={Styles.input_enter_btn}>
              <button type="submit">SELECT MY CAR</button>
            </div>
          </div>
        </>
      )}
    </form>
  );
};

export default Hero;